/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Right_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Center right" |
*
* @param {Position_Center_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_right_aria_label = /** @type {((inputs?: Position_Center_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au centre a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中右")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro-direita")
	return /** @type {LocalizedString} */ ("Center right")
});